import { MaterialDto, SearchMaterialRequest } from './../../shared/model/materiales';
import { MaterialesService } from './../../shared/services/materiales.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { MenuFuncionService } from '../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, SearchTipoMaterialRequest, SearchUnidadMedidaRequest, TipoMaterialDto, UnidadMedidaDto } from '../../../../src/app/shared/model';
import { DatePipe } from '@angular/common';
import { TipoMaterialService } from '../../../../src/app/shared/services/tipo-materiales.service';
import { UnidadMedidaService } from '../../../../src/app/shared/services/unidad-medida.service';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-materiales-list',
  templateUrl: './materiales-list.component.html',
  styleUrls: ['./materiales-list.component.scss']
})

export class MaterialesListComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isTipoSearching: boolean = false;
  canEdit: boolean = false;
  canView: boolean = false;
  canAdd: boolean = false;
  verSoloActivos: boolean = true;
  isTipoMaterialSearching: boolean = false;
  isUnidadMedidaSearching: boolean = false;

  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  tipoMaterialList: TipoMaterialDto[];
  unidadMedidaList: UnidadMedidaDto[];

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private datePipe: DatePipe,
    private menuService: MenuFuncionService,
    private tipoMaterialService: TipoMaterialService,
    private unidadMedidaService: UnidadMedidaService,
    private materialesService: MaterialesService
  ) { }

  ngOnInit(): void {this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.MATERIAL).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result){
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.MATERIAL_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.MATERIAL_LIST);
        if (this.canView){
          this.loadView();
        } else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.router.navigate(['/']);
        }
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.getTiposMateriales();
    this.getUnidadesMedida();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.setQueryParams();
    this.data = new DataManager({
      url: this.materialesService.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.materialesService.getAuthorizationHeader(),this.materialesService.getTenantHeader()]
    });
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'Nombre': [null],
      'TipoMaterialId': [null],
      'UnidadMedidaId': [null]
    });
  }

  getTiposMateriales() {
    var r = new SearchTipoMaterialRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoMaterialSearching = true;

    this.tipoMaterialService.search(r).subscribe(data => {
      this.isTipoMaterialSearching = false;
      this.tipoMaterialList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMaterialSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getUnidadesMedida() {
    var r = new SearchUnidadMedidaRequest(null, null, true, "Nombre", null, null, true);
    this.isUnidadMedidaSearching = true;

    this.unidadMedidaService.search(r).subscribe(data => {
      this.isUnidadMedidaSearching = false;
      this.unidadMedidaList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadMedidaSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

   var index = this.query.params.findIndex(obj => obj.key === "Nombre");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Nombre;
    else
      this.query.addParams("Nombre",this.searchForm.value.Nombre);

    index = this.query.params.findIndex(obj => obj.key === "TipoMaterialId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.TipoMaterialId;
    else
      this.query.addParams("TipoMaterialId",this.searchForm.value.TipoMaterialId);

    index = this.query.params.findIndex(obj => obj.key === "UnidadMedidaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.UnidadMedidaId;
    else
      this.query.addParams("UnidadMedidaId",this.searchForm.value.UnidadMedidaId);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.verSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos",this.verSoloActivos.toString());
  }

  add() {
    if(this.canAdd) {
      this.router.navigate(['material-edit', 0]);
    }else {
      this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
      this.router.navigate(['/']);
    }
  }

  edit(item: MaterialDto) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['material-edit', item.Id]);
  }

  onExport() {
    var search = new SearchMaterialRequest(null, null, null, "", null, null, null,  this.verSoloActivos);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.materialesService.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Materiales_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}

